import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Simulator } from "./pages/Simulator";
import { AdminLogin } from "./pages/admin/AdminLogin";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { Simulazioni } from "./pages/admin/Simulazioni";
import { SimulazioneDetail } from "./pages/admin/SimulazioneDetail";
import { Canali } from "./pages/admin/Canali";
import { Parametri } from "./pages/admin/Parametri";
import { ChangePassword } from "./pages/admin/ChangePassword";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Simulator />} />
          <Route path="/assocamuna" element={<Simulator cobrand />} />
          <Route path="/c/:slug" element={<Simulator />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Simulazioni />} />
            <Route path="sim/:id" element={<SimulazioneDetail />} />
            <Route path="canali" element={<Canali />} />
            <Route path="parametri" element={<Parametri />} />
            <Route path="cambia-password" element={<ChangePassword />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
